import React, { createContext, useContext, useEffect, useState } from 'react';
import { GlobalDebugPanel } from './GlobalDebugPanel';
import { debugLogger, registerModuleSetter } from '../../hooks/useDebugLogger';
import { DebugModule } from '../../types/debug';

interface DebugContextType {
  currentModule: DebugModule;
  setCurrentModule: (module: DebugModule) => void;
}

const DebugContext = createContext<DebugContextType>({
  currentModule: 'general',
  setCurrentModule: () => {}
});

export const useDebugContext = () => useContext(DebugContext);

interface DebugProviderProps {
  children: React.ReactNode;
}

export const DebugProvider: React.FC<DebugProviderProps> = ({ children }) => {
  const [currentModule, setCurrentModule] = useState<DebugModule>('general');

  // Register our setCurrentModule function so useDebugLogger can call it directly
  useEffect(() => {
    registerModuleSetter(setCurrentModule);
  }, []);

  return (
    <DebugContext.Provider value={{ currentModule, setCurrentModule }}>
      {children}
      {/* Global debug panel - automatically shows when enabled */}
      <GlobalDebugPanel />
    </DebugContext.Provider>
  );
};
